module.exports = __webpack_public_path__ + "static/img/img4.b0c0440.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img4.jpg
// module id = Gg6b
// module chunks = 0